/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { CompanyService } from 'src/app/pages/companies/services/company.service';
import { IDevice } from 'src/app/pages/devices/models/device.interface';
import { FilasService } from '../../services/filas.service';
import { DeviceService } from 'src/app/pages/devices/services/device.service';
import { EFilaTabsEdit } from '../../data/fila-tabs-edit.enum';
import { AtendenteService } from 'src/app/pages/atendentes/services/atendente.service';
import { ICompany } from '../../../companies/models/company.interface';
import { IAttendant, IBaseFilter } from '../../data/lista.interface';

@Component({
  selector: 'app-edit-fila',
  templateUrl: './edit-fila.component.html',
  styleUrls: ['./edit-fila.component.scss']
})
export class EditFilaComponent implements OnInit {
  queueId = '';
  formFila = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl('', [Validators.required]),
    companyId: new UntypedFormControl(null, [Validators.required]),
    onlineSupportEmail: new UntypedFormControl('', [Validators.email]),
    offlineSupportEmail: new UntypedFormControl('', [Validators.email]),
    showPatientData: new UntypedFormControl(false)
  });
  ERoleAdminString = ERoleAdminString;
  EFilaTabsEdit = EFilaTabsEdit;
  tabSelecionada: EFilaTabsEdit = EFilaTabsEdit.Filas;
  companyId?: string;
  partnerId?: string;
  accountRole?: string;
  ordenarControl = new UntypedFormControl(1);
  formInput = new UntypedFormControl();

  queuePartnerId?: string;

  queueDevices: IDevice[] = [];
  dadosPaginacaoDevices = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  queueAtendentes: IAttendant[] = [];
  dadosPaginacaoAtendentes = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  companies: ICompany[] = [];

  constructor(
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly sessionService: SessionService,
    private readonly filaService: FilasService,
    private readonly deviceService: DeviceService,
    private readonly atendenteService: AtendenteService
  ) {}

  public ngOnInit(): void {
    this.queueId = this.activatedRoute.snapshot.paramMap.get('id')!;
    this.partnerId = this.sessionService.getSession().partnerId;
    this.accountRole = this.sessionService.getSession().accountRole;

    this.companyService.listarEmpresasAtivas().subscribe((resposta) => {
      this.companies = resposta.data;
    });

    if (this.queueId) {
      this.carregarDetalhesFila(this.queueId);
      this.carregarDevices();
      this.carregarAtendentes();
    }

    this.formFila.get('companyId')!.valueChanges.subscribe((companyId) => {
      this.companyId = companyId;
    });
  }

  public carregarDetalhesFila(queueId: string): void {
    this.filaService.detalhesFila(queueId).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }

      if (resposta.isSucceed) {
        this.formFila.get('name')!.patchValue(resposta.data.name);
        this.formFila.get('description')?.setValue(resposta.data.description);
        this.formFila.get('companyId')!.patchValue(resposta.data.companyId);
        this.formFila.get('onlineSupportEmail')?.setValue(resposta.data.onlineSupportEmail ?? '');
        this.formFila.get('offlineSupportEmail')?.setValue(resposta.data.offlineSupportEmail ?? '');
        this.formFila.get('showPatientData')?.setValue(resposta.data.showPatientData ?? false);
        this.queuePartnerId = resposta.data.company.partnerId;
      }
    });
  }

  public editarFila(): void {
    if (this.formFila.valid) {
      this.filaService.editarFila(this.formFila.getRawValue(), this.queueId).subscribe((resposta) => {
        if (resposta.messages && resposta.messages.length > 0) {
          this.toastService.toast(resposta.messages);
        }

        this.router.navigateByUrl('/dash/filas');
      });
    }
  }

  public mudarTabSelecionada(tabSelecionada: EFilaTabsEdit): void {
    this.tabSelecionada = tabSelecionada;
  }

  public carregarDevices(): void {
    const filter: IBaseFilter = {
      pageNumber: this.dadosPaginacaoDevices.paginaSelecionada,
      pageSize: this.dadosPaginacaoDevices.tamanhoPagina,
      orderBy: this.dadosPaginacaoDevices.ordenacao
    };

    this.filaService.listDevicesInQueue(this.queueId, filter).subscribe((res) => {
      this.queueDevices = res.data;
      this.dadosPaginacaoDevices.totalPaginas = Math.ceil(res.count! / this.dadosPaginacaoDevices.tamanhoPagina);
      this.dadosPaginacaoDevices.itensTotal = res.count!;
    });
  }

  public mudouPaginaDevices(paginaSelecionada: number): void {
    this.dadosPaginacaoDevices.paginaSelecionada = paginaSelecionada;

    this.carregarDevices();
  }

  public mudouTamanhoPaginaDevices(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoDevices.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacaoDevices.paginaSelecionada = 0;

    this.carregarDevices();
  }

  public carregarAtendentes(): void {
    const filtros: IBaseFilter = {
      orderBy: Number(this.dadosPaginacaoAtendentes.ordenacao),
      pageNumber: Number(this.dadosPaginacaoAtendentes.paginaSelecionada),
      pageSize: Number(this.dadosPaginacaoAtendentes.tamanhoPagina)
    };

    this.filaService.listAttendantsInQueue(this.queueId, filtros).subscribe((res) => {
      this.queueAtendentes = res.data;
      this.dadosPaginacaoAtendentes.totalPaginas = Math.ceil(res.count! / this.dadosPaginacaoAtendentes.tamanhoPagina);
      this.dadosPaginacaoAtendentes.itensTotal = res.count!;
    });
  }

  public mudouPaginaAtendentes(paginaSelecionada: number): void {
    this.dadosPaginacaoAtendentes.paginaSelecionada = paginaSelecionada;

    this.carregarAtendentes();
  }

  public mudouTamanhoPaginaAtendentes(itensPaginaSelecionada: number): void {
    this.dadosPaginacaoAtendentes.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacaoAtendentes.paginaSelecionada = 0;

    this.carregarAtendentes();
  }
}
